import theme from '@/theme';
import styled from '@emotion/styled';

export const PopoverRoot = styled.div`
    z-index: 10;
    outline: none;
`;

export const popOverContainerStyle = `
padding: 12px;
border-radius: 8px;

background-color: ${theme.colors.secondary.main};
color: white;

font-size: 12px;
    
`;

export const PopoverContentContainer = styled.p`
    display: flex;
    flex-direction: column;
    ${popOverContainerStyle}
`;
